// ** Import Functions
import { createParamsListForTable } from '@src/utility/helpFunctions'

// Server config
let serverConfig = false

if (process.env.REACT_APP_NODE_ENV === 'development') {
   serverConfig = {
      path: 'http://167.99.252.5:8080',
      api:  'http://167.99.252.5:8080/api/admin/v1'
   }
}
if (process.env.REACT_APP_NODE_ENV === 'production') {
   serverConfig = {
      path: 'https://server.mfauto.com.ua',
      api:  'https://server.mfauto.com.ua/api/admin/v1'
   }
}

// Endpoints list
const endPoints = {
   getUserProfileDetails: '/profile',

   getCustomersList: '/customers',
   getCustomersShortList: '/customers/short-list',
   addCustomer: '/customers',
   getCustomer: '/customers/{value}',
   updateCustomer: '/customers/{value}',
   removeCustomer: '/customers/{value}',
   addContact: '/customers/{value}/contact',
   updateContact: '/customers/{value}/contact',
   removeContact: '/customers/{value1}/contact/{value2}',
   addRelative: '/customers/{value}/relative',
   updateRelative: '/customers/{value}/relative',
   removeRelative: '/customers/relative/{value}',
   customerUploadFile: '/files/{value}',
   reactivateCustomer: '/customers/{value}/reactivate',
   resetPassword: '/customers/{value}',
   checkBlacklistCustomer: '/customers/blacklist',
   addToBlacklist: '/customers/{value}/black-list',
   removeFromBlacklist: '/customers/{value}/black-list',
   changeCusmtomerStatus: '/customers/{value}/status',

   getCompany: '/company',
   updateCompany: '/company',
   getPermissions: '/roles/permissions',
   addPermission: '/roles',
   updatePermission: '/roles/{value}',
   removePermission: '/roles/{value}',
   getUsers: '/users',
   addUser: '/users',
   getUser: '/users/{value}',
   updateUser: '/users/{value}',   
   deactivateUser: '/users/{value}',
   getProfile: '/profile',
   updateProfile: '/profile',
   profileUploadAvatar: '/files/{value}',
   getCurrentSubscription: '/subscriptions',
   getSubscriptionPlans: '/subscriptions/plans',
   getUserActions: '/user-actions',

   getCarsList: '/cars',
   addCar: '/cars',
   getCarsShortList: '/cars/short-list',
   getCarBrands: '/cars/brands',
   getCar: '/cars/{value}',
   updateCar: '/cars/{value}',
   removeCar: '/cars/{value}',
   carUploadFile: '/files/{value}',
   carCustomerHistory: '/cars/customer-history',
   carByIdCustomerHistory: '/cars/{value}/customer-history',
   changeCarStatus: '/cars/{value}/status',
   addCarStatusComment: '/cars/customer-history/{value}/comment',
   removeCarStatusComment: '/cars/customer-history/comment/{value}',

   getCreditsList: '/credits',
   addCredit: '/credits',
   editCredit: '/credits/{value}',
   getCredit: '/credits/{value}',
   getCreditPeriods: '/credits/{value}/periods',
   getCreditSettings: '/credit-settings',
   addCreditSettings: '/credit-settings',
   updateCreditSettings: '/credit-settings/{value}',
   removeCreditSettings: '/credit-settings/{value}',
   getFirstPayemntPayments: '/credits/{value}/first-payments',
   changeCreditStatus: '/credits/{value}',
   recalculateCredit: '/credits/{value}/recalculate',
   calculateCredit: '/credits/{value}/calculate',
   calculateTotalAmount: '/credits/calculate-total-amount',
   creditPeriodVisited: '/credits/visit/{value}',
   additionalExpensesList: '/credits/{value}/operations',
   addAdditionalExpense: '/credits/{value}/add-additional-expenses',
   removeAdditionalExpense: '/credits/stop-additional-expenses/{value}',
   addCreditDynamicDeposit: '/api/admin/v1/credits/{value}/custom-deposit',
   changeNoteCreditStatus: '/api/admin/v1/credits/{value}/update-note-status',
   editCreditPaymentDate: '/api/admin/v1/credits/{value}/expected-payment-day',

   getRentsList: '/rents',
   addRent: '/rents',
   getRent: '/rents/{value}',
   stopRent: '/rents/{value}',
   addDynamicDeposit: '/rents/{value}/custom-deposit',
   removeDynamicDeposit: '/rents/custom-deposit/{value}',
   addRentPeriodDetails: '/rents/{value}/period-info',
   closeRentPeriod: '/rents/{value}/close-period',
   createRentPeriod: '/rents/{value}/create-next-period',
   shiftRentPeriod: '/rents/{value}/shift-next-period',
   setLastRentPeriod: '/rents/{value}/update-end-date',
   getRentSettings: '/rent-settings',
   addRentSettings: '/rent-settings',
   updateRentsettings: '/rent-settings/{value}',
   removeRentSettings: '/rent-settings/{value}',
   carReplacement: '/rents/{value}/car-replacement',
   setRentPrice: '/rents/{value}/update-expected-payment',
   updateActualPeriodPrice: '/rents/{value}/update-actual-period-price',
   deleteCurrentPeriod: '/rents/{value}/delete-current-period',
   rentPeriodVisited: '/rents/visit/{value}',
   rentPause: '/rents/{value}/pause',
   rentResume: '/rents/{value}/resume',

   addPayment: '/payments/create',
   removePayment: '/payments/refund/{value}',

   getExchangeRate: '/exchange-rate',
   updateExchangeRate: '/exchange-rate/{value}',

   getDepositsList: '/deposits',

   getInsurancesList: '/car-insurance',
   getInsurance: '/car-insurance/{value}',
   addInsurance: '/car-insurance',
   removeInsurance: '/car-insurance/{value}',

   getFiles: '/files',
   getFilesByParams: '/files/{value}',
   uploadFile: '/files/{value}',
   removeFile: '/files/{value}',

   getAccidentsList: '/road-accidents',
   addAccident: '/road-accidents',
   getAccident: '/road-accidents/{value}',
   updateAccident: '/road-accidents/{value}',
   completeAccident: '/road-accidents/{value}/complete',
   addAccidentInsuranceAppeal: '/road-accidents/{value}/insurance-appeal',
   updateAccidentInsuranceAppeal: '/road-accidents/insurance-appeal/{value}',
   addAccidentInsuranceAppealExpectedPayment: '/road-accidents/insurance-appeal/{value}/expected-payment',
   removeAccidentInsuranceAppealEexpectedPayment: '/road-accidents/insurance-appeal/expected-payment/{value}',
   updateAccidentInsuranceAppealExpertExamined: '/road-accidents/insurance-appeal/{value}/expert-examined',
   removeAccidentAppeal: '/road-accidents/insurance-appeal/{value}',
   restoreAccident: '/road-accidents/{value}/restore',

   getPaymentsList: '/finance',
   getPaymentSubTypes: '/company/payment-subtypes', // get
   addPaymentSubTypes: '/company/payment-subtypes', // post
   updatePaymentSubTypes: '/company/payment-subtypes/{value}', // put
   removePaymentSubTypes: '/company/payment-subtypes/{value}', // delete
   activatePaymentSubTypes: '/company/payment-subtypes/{value}/activate', // put
   getAccounts: '/payment-accounts',
   addAccount: '/payment-accounts',
   updateAccount: '/payment-accounts/{value}',
   removeAccount: '/payment-accounts/{value}',
   getAccessRoles: '/payment-accounts/{value}/access',
   updateAccountAccess: '/payment-accounts/{value}/access',
   getAccountBalance: '/payment-accounts/{value}/balance',
   approvePayment: '/payments/approve/{value}',
   getRelatedPayments: '/finance/relate',
   addPaymentRelation: '/payments/relate',
   deleteRelatedPayment: '/payments/relate',

   getWarehouses: '/api/service-station/v1/stocks/list',
   addWarehouse: '/api/service-station/v1/stocks',
   getWarehouse: '/api/service-station/v1/stocks/{value}',
   updateWarehouse: '/api/service-station/v1/stocks/{value}',
   removeWarehouse: '/api/service-station/v1/stocks/{value}',
   getWarehouseProductsList: '/api/service-station/v1/stock-items/list',
   transferWarehouseProducts: '/api/service-station/v1/stock-items/transfer',

   getSuppliers: '/api/service-station/v1/stocks/suppliers',
   addSupplier: '/api/service-station/v1/stocks/suppliers',
   getSupplier: '/api/service-station/v1/stocks/suppliers/{value}',
   updateSupplier: '/api/service-station/v1/stocks/suppliers/{value}',
   removeSupplier: '/api/service-station/v1/stocks/suppliers/{value}',
   
   getSuppliesList: '/api/service-station/v1/stocks/supplies/list',
   addSupply: '/api/service-station/v1/stocks/supplies',
   getSupply: '/api/service-station/v1/stocks/supplies/{value}',

   getProductGroups: '/api/service-station/v1/item-groups/list',
   getProductGroupChildren: '/api/service-station/v1/item-groups/{value}/children',
   addProductGroup: '/api/service-station/v1/item-groups',
   getProductGroup: '/api/service-station/v1/item-groups/{value}',
   editProductGroup: '/api/service-station/v1/item-groups/{value}',
   removeProductGroup: '/api/service-station/v1/item-groups/{value}',

   getProductsList: '/api/service-station/v1/items/list',
   addProduct: '/api/service-station/v1/items',
   getProduct: '/api/service-station/v1/items/{value}',
   updateProduct: '/api/service-station/v1/items/{value}',
   removeProduct: '/api/service-station/v1/items/{value}',
   getProductAvailability: '/api/service-station/v1/items/availability',
   getProductStock: '/api/service-station/v1/stock-items/{value}',
   addProductStockQuantity: '/api/service-station/v1/stock-items',
   updateProductStockQuantity: '/api/service-station/v1/stock-items/{value}',

   getServiceGroups: '/api/service-station/v1/service-definition-groups/list',
   getServiceGroupChildren: '/api/service-station/v1/service-definition-groups/{value}/children',
   addServiceGroup: '/api/service-station/v1/service-definition-groups',
   getServiceGroup: '/api/service-station/v1/service-definition-groups/{value}',
   editServiceGroup: '/api/service-station/v1/service-definition-groups/{value}',
   removeServiceGroup: '/api/service-station/v1/service-definition-groups/{value}',

   getServicesList: '/api/service-station/v1/service-definitions/list',
   addService: '/api/service-station/v1/service-definitions',
   getService: '/api/service-station/v1/service-definitions/{value}',
   updateService: '/api/service-station/v1/service-definitions/{value}',
   removeService: '/api/service-station/v1/service-definitions/{value}',

   getStations: '/api/service-station/v1/service-stations/list',
   addStation: '/api/service-station/v1/service-stations',
   getStation: '/api/service-station/v1/service-stations/{value}',
   updateStation: '/api/service-station/v1/service-stations/{value}',
   removeStation: '/api/service-station/v1/service-stations/{value}',

   getServiceClients: '/api/service-station/v1/clients/list',
   addServiceClient: '/api/service-station/v1/clients',
   getServiceClient: '/api/service-station/v1/clients/{value}',
   updateServiceClient: '/api/service-station/v1/clients/{value}',
   removeServiceClient: '/api/service-station/v1/clients/{value}',

   getServiceCars: '/api/service-station/v1/cars/list',
   addServiceCar: '/api/service-station/v1/cars',
   getServiceCar: '/api/service-station/v1/cars/{value}',
   updateServiceCar: '/api/service-station/v1/cars/{value}',
   removeServiceCar: '/api/service-station/v1/cars/{value}',

   getServiceEmployees: '/api/service-station/v1/employees/list',
   addServiceEmployee: '/api/service-station/v1/employees',
   updateServiceEmployee: '/api/service-station/v1/employees/{value}',
   getServiceEmployee: '/api/service-station/v1/employees/{value}',
   removeServiceEmployee: '/api/service-station/v1/employees/{value}',

   getServiceEmployeeRoles: '/api/service-station/v1/employees/roles/list',
   addServiceEmployeeRole: '/api/service-station/v1/employees/roles',
   updateServiceEmployeeRole: '/api/service-station/v1/employees/roles/{value}',   
   removeServiceEmployeeRole: '/api/service-station/v1/employees/roles/{value}',

   getServiceEmployeeSkills: '/api/service-station/v1/employees/skills/list',
   addServiceEmployeeSkills: '/api/service-station/v1/employees/skills',
   updateServiceEmployeeSkill: '/api/service-station/v1/employees/skills/{value}',
   removeServiceEmployeeSkill: '/api/service-station/v1/employees/skills/{value}',

   getRepairActs: '/api/service-station/v1/acts/list',
   addRepairAct: '/api/service-station/v1/acts',
   updateRepairAct: '/api/service-station/v1/acts/{value}',
   getRepairAct: '/api/service-station/v1/acts/{value}',
   removeRepairAct: '/api/service-station/v1/acts/{value}',
   completeRepairAct: '/api/service-station/v1/acts/{value}/complete',
   addRepairActService: '/api/service-station/v1/acts/{value}/service',
   addRepairActProduct: '/api/service-station/v1/acts/{value}/reservations',
   confirmRepairActProduct: '/api/service-station/v1/acts/confirm-reservations',
   confirmAllRepairActProduct: '/api/service-station/v1/acts/{value}/confirm-reservations',
   removeRepairActService: '/api/service-station/v1/acts/service/{value}',
   removeRepairActProduct: '/api/service-station/v1/acts/reject-reservations',
   updateRepairActService: '/api/service-station/v1/acts/service/{value}',
   addRepairActRequestedProduct: '/api/service-station/v1/acts/{value}/requested-items',
   updateRepairActRequestedProduct: '/api/service-station/v1/acts/requested-items/{value}',
   removeRepairActRequestedProduct: '/api/service-station/v1/acts/requested-items/{value}',

   getPromissoryNoteList: '/api/admin/v1/promissory-notes/list',
   getPromissoryNote: '/api/admin/v1/promissory-notes/{value}',
   addPromissoryNote: '/api/admin/v1/promissory-notes',
   getPromissoryNotePeriods: '/api/admin/v1/promissory-notes/{value}/periods',
   changePromissoryNoteStatus: '/api/admin/v1/promissory-notes/{value}/stop',
   recalculatePromissoryNote: '/api/admin/v1/promissory-notes/{value}/recalculate',
   calculatePromissoryNote: '/api/admin/v1/promissory-notes/{value}/calculate',
   promissoryNotePeriodVisited: '/api/admin/v1/promissory-notes/visit/{value}',

   investorUploadFile: '/files/{value}',

   getHaulList: '/api/admin/v1/hauls/list',
   getHaul: '/api/admin/v1/hauls/{value}',
   addHaul: '/api/admin/v1/hauls',
   updateHaul: '/api/admin/v1/hauls/{value}',
   removeHaul: '/api/admin/v1/hauls/{value}',
   finishHaul: '/api/admin/v1/hauls/{value}/finish',
   addHaulExpense: '/api/admin/v1/hauls/{value}/expenses',
   removeHaulExpense: '/api/admin/v1/hauls/{value1}/expenses/{value2}',   
   addHaulFuel: '/api/admin/v1/hauls/{value}/fuels',
   removeHaulFuel: '/api/admin/v1/hauls/{value1}/fuels/{value2}'

}

export const ttl_delay = 10// mins

export const checkTtlExpired = (ttl) => {
   const result = Math.ceil((new Date().getTime() - ttl.getTime()) / (1000 * 60 * 1))
   return result > ttl_delay
}

export const apiLink = (endPoint, params = null, clear_params = true) => {

   const uri = params !== null ? createParamsListForTable(params, clear_params) : ''
   if (typeof endPoint === 'object') {

      const startLink = endPoints[endPoint.name].includes('/api/') ? serverConfig.path : serverConfig.api

      if (endPoint.values !== undefined) {

         let path = endPoints[endPoint.name]

         endPoint.values.map((item, index) => {
            path = path.replace(`{value${index + 1}}`, item)
         })

         return startLink + path + uri
      }      

      return startLink + endPoints[endPoint.name].replace('{value}', endPoint.value) + uri

   } else {

      const startLink = endPoints[endPoint].includes('/api/') ? serverConfig.path : serverConfig.api

      return startLink + endPoints[endPoint] + uri
      
   }

}

export { serverConfig }

export default apiLink